import travelClient from './travelClient';
import { TRAVEL_API } from './endpoints';

function parse(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  return JSON.parse(raw.replace(/("locationId"\s*:\s*)(\d{15,})/g, '$1"$2"'));
}
const config = { transformResponse: [parse] };
export const discoveryDestinationApi = {
  list: (parentKey, options = {}) => travelClient.get(`${TRAVEL_API}/discovery/destinations`, {
    ...config, signal: options.signal, params: parentKey ? { parentKey } : {},
  }),
  resolve: (key, options = {}) => travelClient.get(`${TRAVEL_API}/discovery/destination`, {
    ...config, signal: options.signal, params: { key },
  }),
};
